/**
 * Closes variant dropdowns (e.g. Metal) when main drawers open:
 * menu drawer, cart drawer, search modal, service drawer, drawer-panel.
 * Prevents dropdowns from appearing over/inside main drawers.
 */
(function () {
  function closeVariantDropdowns() {
    document
      .querySelectorAll('details.variant-option--tds-compact[open], details.variant-option--metal[open]')
      .forEach((el) => el.removeAttribute('open'));
  }

  // Dialog-based drawers (cart, search, service, drawer-panel)
  document.addEventListener('dialog:open', closeVariantDropdowns);

  // Menu drawer: details#Details-menu-drawer-container
  document.addEventListener(
    'toggle',
    (e) => {
      if (
        e.target instanceof HTMLDetailsElement &&
        e.target.open &&
        e.target.id === 'Details-menu-drawer-container'
      ) {
        closeVariantDropdowns();
      }
    },
    true
  );
})();
